import { useState } from "react";

import { toDollars } from "common/utils/formatting";
import { UserSubscriptionAction } from "common/types";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import QuantityInput from "client/common/components/inputs/QuantityInput";
import { DetailSubscription } from "client/subscriptions/types";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { useUpdateSubscriptionMutation } from "../../hooks";

import styles from "../../styles/SubscriptionUpdateQuantityDrawer.module.less";

export type SubscriptionQuantityUpdateDrawerProps = {
  subscription: DetailSubscription;
};

const SubscriptionQuantityUpdateDrawer = ({
  subscription,
}: SubscriptionQuantityUpdateDrawerProps) => {
  const { close } = useCurrentDrawer();
  const {
    mutate: update,
    isLoading,
    error,
  } = useUpdateSubscriptionMutation(subscription.id, {
    onSuccess: close,
  });

  const [quantity, setQuantity] = useState(subscription.quantity);

  return (
    <DrawerLayout>
      <DrawerLayout.Header
        title="Update quantity"
        description="This will update the quantity for all future orders of this Autoship"
        onClose={close}
      />
      <DrawerLayout.Form
        canSubmit={true}
        onSubmit={() =>
          update({
            action: UserSubscriptionAction.Modify,
            quantity,
          })
        }
        submitText="Update quantity"
        isLoading={isLoading}
        error={error}
        fieldErrors={[error?.errors.action, error?.errors.quantity]}
      >
        <DrawerLayout.Form.Group>
          <div className={styles.selections}>
            <QuantityInput min={1} value={quantity} onChange={setQuantity} />
            <div className={styles.prices}>
              <p className={styles.price}>
                {toDollars(quantity * subscription.next_order_data.unit_price)}
              </p>
              <p className={styles.priceLabel}>Subtotal</p>
            </div>
          </div>
        </DrawerLayout.Form.Group>
      </DrawerLayout.Form>
    </DrawerLayout>
  );
};

export default SubscriptionQuantityUpdateDrawer;
